export const ACCESSIBLE_TITLE = 'clubmed-accessible-title';
export const BEFORE_APP = 'clubmed-portal-before';
export const AFTER_APP = 'clubmed-portal-after';
export const OVER_BOT = 'clubmed-portal-over';
